import { useEffect, useState } from 'react';
import io, { Socket } from 'socket.io-client';
import { apiUrl } from './axiosInstance';
import * as Sentry from '@sentry/react';

export const useSocket = () => {
  const [socket, setSocket] = useState<Socket | null>(null);

  useEffect(() => {
    const newSocket = io(apiUrl);

    // Listen for connection errors
    newSocket.on('connect_error', (error: Error) => {
      Sentry.captureException(error);
      console.error('Connection Error:', error);
    });

    // Listen for generic socket errors
    newSocket.on('error', (error: Error) => {
      Sentry.captureException(error);
      console.error('Socket Error:', error);
    });

    setSocket(newSocket);

    return () => {
      newSocket.disconnect();
    };
  }, []);

  return socket;
};
